module.exports = __webpack_public_path__ + "media/img/frontend_application/stripe-img-c5fdb2c83dff2b0556775c365ddfa039.png";